import { Stack, TextField, Button, Divider } from '@mui/material'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { newTemplateActions } from "../../../../redux/slices/newTemplateSlice";

import React, { useState, useRef, useEffect } from 'react'

function NtwJSONTemplate() {
  const [jsonFileVal, setjsonFileVal] = useState('')
  const [jsonData, setJsonData] = useState('')
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const fileBrowser = useRef();
  const newTemplate = useSelector(state => state.newTemplate)
  const error = useRef();
  // const label = newTemplate.newTemplateOption === t('BTN_CREATE_FROM_DATA') ? `${t('FRG_ENTER_FULL_PATH_TO_')+' '+t('JSON')}` : `${t('FRG_ENTER_FULL_PATH_TO_')+' '+t('JSON_SCHEMA')}`;
  const textAreaLabel = newTemplate.newTemplateOption === t('BTN_CREATE_FROM_DATA') ? `${t('TXT_PASTE_JSON_TEMPLATE_DATA_HERE')}` : `${t('TXT_PASTE_JSON_TEMPLATE_SCHEMA_HERE')}`
  const label = newTemplate.newTemplateOption === t('BTN_CREATE_FROM_DATA') ? 'Choose JSON File' : 'Choose JSON Schema File'

  const handleUploadClick = (e) => {
    const file = e.target.files[0];
    setjsonFileVal(file?.name)
    const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.')
    dispatch(newTemplateActions.setTemplateName(fileNameWithoutExtension))

    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileInfo = e.target.result;
        dispatch(newTemplateActions.setJSONTemplateData({ fileInfo }));
      };
      reader.readAsText(file);
    }
  };
  const handleJSONPaste = (e) => {
    const val = e.target.value
    setJsonData(val);
    if (!newTemplate?.JSONTemplateData?.hasOwnProperty('fileInfo')) dispatch(newTemplateActions.setJSONTemplateData({ data: val }))

  }
  useEffect(() => {
    dispatch(newTemplateActions.setIsFormData(true))
  }, [])
  return (
    <>
      <Stack spacing={"8px"}>
        <div className='flex'>
          <TextField
            className='width-100'
            label={label}
            variant="outlined"
            size='small'
            value={jsonFileVal}
            onChange={(e) => {
              error.current.textContent = ""
            }}
            autoComplete="off"
          >
          </TextField>
          <input
            style={{ display: "none" }}
            type="file"
            ref={fileBrowser}
            onChange={(e) => {
              // setjsonFileVal(e.target.value)
              error.current.textContent = "";
              handleUploadClick(e);
            }}
          />
          <Button
            variant="outlined"
            size="small"
            disableElevation
            className="margin-left-4"
            sx={{
              width: "40px",
              padding: "4px 8px",
              minWidth: "40px",
            }}
            onClick={() => {
              fileBrowser.current.click();
            }}>
            <DriveFolderUploadIcon fontSize="small" />
          </Button>
        </div>
        <div>
          <p className="error" ref={error}></p>
        </div>
        <Divider style={{marginTop: "0"}}>{t('OR')}</Divider>
        <div style={{ width: '100%' }}>
          <TextField
            variant='outlined'
            className='width-100'
            size='medium'
            label={textAreaLabel}
            rows={10}
            multiline
            value={jsonData}
            onChange={(e) => {
              handleJSONPaste(e)
            }}
          />
        </div>
      </Stack>
      <Divider></Divider>

    </>
  )
}

export default NtwJSONTemplate